<template>
    <div class="timeline-title">

        <slot name="top_outside"></slot>

        <div class="pb-0 pt-5 pr-0 pl-7" :class="[ options.color && options.color.bgContent ? options.color.bgContent : '',
                                             options.position && options.position.bgContent ? options.position.bgContent : '', ] ">


            <slot name="top"></slot>


            <span class="timeline-title__year" :class='[
                    options.fontSize && options.fontSize.year || `text-base`,
                    options.color && options.color.year || `text-flamingo`
            ]' v-html="options.year"></span>
            <h5 class="timeline-title__toptitle" :class='[
                    options.fontSize && options.fontSize.toptitle || `text-base`,
                    options.color && options.color.toptitle || `text-dodger_blue`,
            ]' v-html="options.toptitle"></h5>
                <h4 class="timeline-title__pretitle" :class='[
                    options.fontSize && options.fontSize.pretitle || `text-2xl`,
                    options.color && options.color.pretitle || `text-dodger_blue`,
            ]' v-html="options.pretitle"></h4>
                <h3 class="timeline-title__title" :class='[
                    options.fontSize && options.fontSize.title || `text-4xl`,
                    options.color && options.color.title || `text-selective_yellow`
            ]' v-html="options.title"></h3>
                <h3 class="timeline-title__subtitle" :class='[
                    options.fontSize && options.fontSize.subtitle || `text-4xl`,
                    options.color && options.color.subtitle || `text-selective_orange`
            ]' v-html="options.subtitle"></h3>
            <div class="flex flex-row w-full">
                <div v-if="options.precontent" class="flex justify-center items-start mr-5 mt-3">
                    <p class="timeline-title__precontent" :class='[
                        options.fontSize && options.fontSize.precontent || `text-base`,
                        options.color && options.color.precontent || `text-nandor`
                    ]' v-html="options.precontent"></p>
                </div>
                <p class="timeline-title__content" :class='[
                    options.fontSize && options.fontSize.content || `text-base`,
                    options.position,
                    options.color && options.color.content || `text-nandor`
            ]' v-html="options.content"></p>
            </div>
            <span class="timeline-title__outerText" :class='[
                    options.fontSize && options.fontSize.outerText || `text-base`,
                    options.color && options.color.outerText || `text-black`
            ]' v-html="options.outerText"></span>

            <slot></slot>

            <slot name="bottom"></slot>
        </div>



    </div>
</template>

<script>
export default {
    components: {},
    name: "TimelineTitle",
    props: {
        options: null,
    },
};
</script>

<style lang="scss" scoped>
.timeline-title {

    @apply relative ;


    &__year {
        @apply absolute transform -rotate-90 font-bold origin-bottom -ml-5 ;
    }

    &__toptitle {
        @apply relative  font-bold uppercase pr-8;
    }

    &__pretitle {
        @apply relative font-bold  uppercase;
    }

    &__title {
        @apply relative  font-bold uppercase;
    }

    &__subtitle {
        @apply relative  font-bold uppercase;
    }

    &__content {
    }

    &__outerText {
        @apply absolute text-sm transform -rotate-90 origin-bottom -ml-24 -mt-28 ;
    }
}
</style>
